import { FC } from 'react'
import Font from 'src/components/Core/Typography/Font/Font'
import Flex from 'src/components/Layout/Flex/Flex'
import styled, { css } from 'styled-components'
import { DayProps } from './types'

const blankValueColor = css`
  h6 {
    color: ${props => props.theme.colors.main.blank};
  }
`

const ultraViolet = css`
  background-color: ${props => props.theme.colors.main.ultraViolet};
  ${blankValueColor}
`

const neutral = css`
  background-color: ${props => props.theme.colors.shades.neutral[2]};
  ${blankValueColor}
`

const tagged = css`
  padding-top: 4px;
  border-bottom: 4px solid ${props => props.theme.colors.main.ultraViolet};
`

const variants = {

  'selected': ultraViolet,

  'tagged': tagged,

  'tagged-today': css`
    ${neutral}
    ${tagged}
  `,

  'today': neutral,

} satisfies Record<string, unknown>

const DayStyle = styled(Flex)<{ $variant: keyof typeof variants | null }>`
  width: 28px;
  height: 28px;
  min-width: 28px;
  min-height: 28px;
  border-radius: 4px;
  box-sizing: border-box;

  ${props => props.$variant && variants[props.$variant]}
`

function getVariant(props: DayProps): keyof typeof variants | null {
  if (props.isDisabled) {
    return null
  }

  if (props.isSelected) {
    return 'selected'
  }

  if (props.isToday && props.isTagged) {
    return 'tagged-today'
  }

  if (props.isToday) {
    return 'today'
  }

  if (props.isTagged) {
    return 'tagged'
  }

  return null
}

const Day: FC<DayProps> = props => {
  const { value } = props

  return (
    <DayStyle $variant={getVariant(props)}>
      <Font tag='h6'>{value}</Font>
    </DayStyle>
  )
}

export default Day
